const DEFAULT_CONSTANTS = {
  success: "success",
  warn: "warning",
  error: "error",
  timeout: 3000,
  toSecond: 3600,
  toMin: 60,
  defaultTimer: "00:00:00",
};

export default DEFAULT_CONSTANTS;
